//@ts-nocheck
import { RedeemRewardsAuthorization } from '../types/commonTypes';
import { ContentfulDashboardType } from '../types/contentfulTypes';
import moment from 'moment';
import CryptoJS from 'crypto-js';
import { getSecretKey } from './KeyManager';
import AsyncStorage, { isWeb } from '../storage';
import SecureLS from 'secure-ls';

export const showNetworkLogger = (type: string, data: any) => {
  if (type === 'request') {
    console.log('-------------Network Begin---------------');
    console.log('===========');
    console.log('API REQUEST');
    console.log('===========');
    console.log('\tMETHOD', data.method);
    console.log('\tURL', data?.baseURL + data.url);
    console.log('\tHEADERS', data.headers);
    console.log('\tDATA', data.data);
    console.log('========================================');
  } else if (type === 'response') {
    console.log('API RESPONSE');
    console.log('============');
    console.log('\tBASEURL', data.config?.baseURL + data.config?.url);
    console.log('RESPONSE DATA', data.data);
    console.log('-------------Network End---------------');
  } else if (type === 'error') {
    console.log('API ERROR');
    console.log('============');
    console.log('\tSTATUS', data ?? '');
    console.log('\tSTATUS', data.status ?? '');
    console.log('\tBASEURL', data.config?.baseURL + data.config?.url);
    console.log('\tMESSAGE', JSON.stringify(data.response));
    console.log('-------------Network End---------------');
  }
};

export const getContentfulDataFields = (data: any) => {
  const entries = data.includes?.Entry || data.items;
  const assets = data.includes?.Asset;

  const contentful: any = {
    entries: {},
    assets: {},
  };

  for (let i = 0; i < entries?.length; i++) {
    contentful.entries[entries[i]?.fields?.title] = entries[i]?.fields;
  }

  for (let i = 0; i < assets?.length; i++) {
    contentful.assets[assets[i]?.fields?.title] =
      `https:${assets[i]?.fields?.file?.url}`;
  }

  return contentful as ContentfulDashboardType;
};

export const maskUsername = (username: string) => {
  if (username.length <= 4) {
    return username;
  }
  const visibleStart = 2;
  const visibleEnd = 2;
  const maskLength = username.length - visibleStart - visibleEnd;
  const maskedPart = '*'.repeat(maskLength);
  return (
    username.slice(0, visibleStart) + maskedPart + username.slice(-visibleEnd)
  );
};

export const passwordRegex = /^(?=.*[0-9])(?=.*[a-zA-Z]).{8,20}$/;

export const changePasswordRegex =
  /^(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,20}$/;

export const formatAmount = (amount: any) => {
  const numericAmount = parseFloat(amount);
  if (isNaN(numericAmount)) {
    return '_ _';
  }
  return numericAmount.toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};

export const maskMobileNumber = (number: string) => {
  if (number.length < 6) return number; // Return the original number if it's too short

  const lastTwo = number.slice(-4);
  const maskedSection = '*'.repeat(number.length - 6); // Create a mask for the middle section
  return `${maskedSection}${lastTwo}`;
};

export function maskPhoneNumber(phone: string): string {
  if (phone.length < 6) {
    return phone;
  }

  const visibleDigits = phone.slice(-4);
  const maskedPart = phone.slice(1, -4).replace(/\d/g, '*');
  return `+${maskedPart}${visibleDigits}`;
}

export const maskEmailID = (email: string) => {
  const [localPart, domainPart] = email.split('@'); // Create a mask for the middle section
  const maskedLocalPart = `${'*'.repeat(Math.max(0, localPart.length - 3))}${localPart.slice(-3)}`;
  const maskedEmail = `${maskedLocalPart}@${domainPart}`;
  return maskedEmail;
};
export const legacyBeautifyAmount = (
  amount: number | string = 0.0
): { formattedIntegerPart: string; decimalPart: string } => {
  // Convert amount to a number if it's a string
  const numAmount = typeof amount === 'string' ? parseFloat(amount) : amount;

  // Split the number into integer and decimal parts
  const [integerPart, decimalPart] = Math.abs(numAmount).toFixed(2).split('.');

  // Add commas to the integer part
  const formattedIntegerPart = integerPart.replace(
    /\B(?=(\d{3})+(?!\d))/g,
    ','
  );

  // Return the formatted amount with exactly two decimal places
  return {
    formattedIntegerPart,
    decimalPart,
  };
};

export const filterFirebaseDeviceID = (id: string) => {
  if (id.length < 10) return id;
  const afterColon = id.split(':')[1];
  const beforeHyphen = afterColon.split('-')[0];
  return beforeHyphen;
};

// Function to format a date from "yyyy-mm-dd" to "Day Month dd, yyyy"
export const formatDate = (dateString: string): string => {
  // Create a new Date object from the input date string
  const date = new Date(dateString); // dateString should be in "yyyy-mm-dd" format

  // Define options for the date format
  const options: Intl.DateTimeFormatOptions = {
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  };

  // Use toLocaleDateString to format the date
  return date.toLocaleDateString('en-US', options); // This will return something like "Sunday, June 3, 2024"
};

// Function to format offer expiry date without timezone issues
export const formatOfferExpiryDate = (
  dateString: string,
  locale: 'en-US' | 'fr' = 'en-US'
): string => {
  if (!dateString) return '';

  try {
    // Use moment to parse the date string and format it
    // This avoids timezone issues by treating the date as a local date
    const date = moment(dateString, 'YYYY-MM-DD');

    if (!date.isValid()) {
      console.warn('Invalid date string provided:', dateString);
      return dateString; // Return original string if parsing fails
    }

    // Set moment locale for proper month names
    const momentLocale = locale === 'fr' ? 'fr' : 'en';
    date.locale(momentLocale);

    // Format based on locale
    if (locale === 'fr') {
      // French format: "DD mois YYYY" (e.g., "31 décembre 2025")
      return date.format('DD MMMM YYYY');
    } else {
      // English format: "Month DD, YYYY" (e.g., "December 31, 2025")
      return date.format('MMMM DD, YYYY');
    }
  } catch (error) {
    console.error('Error formatting offer expiry date:', error);
    return dateString; // Return original string on error
  }
};

export const getFirstAndLastDateOfMonth = (
  monthYear: string,
  locale: 'en-US' | 'fr' = 'en-US' // Language parameter, default is 'en' for English
): { firstDate: string; lastDate: string } => {
  const [monthName, year] = monthYear.split(' ');

  // List of month names and their corresponding index (0-based index for months) in both English and French
  const monthNames: { [key: string]: number } =
    locale === 'fr'
      ? {
          Janvier: 0,
          Février: 1,
          Mars: 2,
          Avril: 3,
          Mai: 4,
          Juin: 5,
          Juillet: 6,
          Août: 7,
          Septembre: 8,
          Octobre: 9,
          Novembre: 10,
          Décembre: 11,
        }
      : {
          January: 0,
          February: 1,
          March: 2,
          April: 3,
          May: 4,
          June: 5,
          July: 6,
          August: 7,
          September: 8,
          October: 9,
          November: 10,
          December: 11,
        };

  // Get the month index based on month name (e.g., "Janvier" -> 0 or "January" -> 0)
  const monthIndex = monthNames[monthName];
  // First day of the given month
  const firstDate = new Date(parseInt(year), monthIndex, 1); // Set to the first day of the month
  // Last day of the given month: Create a new Date for the first day of the next month and subtract one day
  const lastDate = new Date(parseInt(year), monthIndex + 1, 0); // Setting the day to 0 will get the last day of the previous month
  // Format both dates as "yyyy-mm-dd"
  const formatDate = (date: Date) => date.toISOString().split('T')[0];
  return {
    firstDate: formatDate(firstDate),
    lastDate: formatDate(lastDate),
  };
};

// Define the transaction data structure
export const formatMonthYear = (month: number, year: number) => {
  const date = new Date(year, month, 1); // Creating a date object from year and month
  const options: Intl.DateTimeFormatOptions = {
    month: 'long',
    year: 'numeric',
  };
  return date.toLocaleDateString('en-US', options); // Format the date to 'Month Year'
};

export const SentenceCase = (str: string) => {
  if (!str) return '';
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
};

export const getPrevious12Months = () => {
  const monthsList = [];
  const currentDate = new Date();

  // Loop through the past 12 months
  for (let i = 0; i < 12; i++) {
    // Create a new Date object for the current month minus i months
    const monthDate = new Date(
      currentDate.getFullYear(),
      currentDate.getMonth() - i,
      1
    );

    // Format the date to "Month Year"
    const formattedMonth = monthDate.toLocaleDateString('en-US', {
      month: 'long',
      year: 'numeric',
    });

    monthsList.push(formattedMonth);
  }

  return monthsList;
};

export const groupByDate = (data: any) => {
  return data.reduce((acc: any, item: any) => {
    const date = moment(item.transactionDateTime).format('YYYY-MM-DD'); // Use the date as the section title

    if (!acc[date]) {
      acc[date] = [];
    }
    acc[date].push(item);

    return acc;
  }, {});
};

export const getFirstAndLastDate = (
  monthYear: string,
  locale: string = 'en' // Language parameter, default is 'en' for English
) => {
  // Parse the string into a moment object (assuming "January 2025" format)
  const monthYearMoment = moment(monthYear, 'MMMM YYYY').locale(locale);

  // Get the first date of the month
  const firstDate = monthYearMoment.startOf('month').format('YYYY-MM-DD');

  // Get the last date of the month
  const lastDate = monthYearMoment.endOf('month').format('YYYY-MM-DD');

  return {
    firstDate,
    lastDate,
  };
};

export const formatCurrency = (amount: number, lang: string): string => {
  const formattedAmount = formatAmount(amount);
  const currencySymbol = '$';

  if (lang === 'fr') {
    return `${formattedAmount}${currencySymbol}`;
  } else {
    return `${currencySymbol}${formattedAmount}`;
  }
};

export const webFormatCurrency = (amount: number, lang: string): string => {
  const { formattedIntegerPart, decimalPart } = legacyBeautifyAmount(amount);
  const currencySymbol = '$';

  if (lang === 'fr') {
    const frenchFormattedInt = formattedIntegerPart.replace(/,/g, ' ');
    return `${frenchFormattedInt},${decimalPart}${currencySymbol}`;
  } else {
    return `${currencySymbol}${formattedIntegerPart}.${decimalPart}`;
  }
};

const generateIV = () => {
  let arr = new Uint8Array(16);
  for (let i = 0; i < arr.length; i++) {
    arr[i] = Math.floor(Math.random() * 256); // Random 0-255
  }
  return CryptoJS.lib.WordArray.create(arr);
};

// Encrypt function
export const encryptAES = (text: string) => {
  const SECRET_KEY_STRING = getSecretKey();
  try {
    const iv = generateIV(); // Generate a new IV
    const encrypted = CryptoJS.AES.encrypt(
      text,
      CryptoJS.enc.Utf8.parse(SECRET_KEY_STRING),
      {
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
      }
    );

    // Concatenate IV and encrypted text, then encode in Base64
    const combined = iv.concat(encrypted.ciphertext);
    return CryptoJS.enc.Base64.stringify(combined);
  } catch (e: any) {
    console.log('encryptAES error', e);
  }
  return '';
};

export const decryptAES = (cipherTextBase64: string): string => {
  const SECRET_KEY_STRING = getSecretKey();

  try {
    const combinedBytes = CryptoJS.enc.Base64.parse(cipherTextBase64);

    // Extract IV from first 16 bytes
    const iv = CryptoJS.lib.WordArray.create(
      combinedBytes.words.slice(0, 4),
      16
    );

    // Extract ciphertext from the remaining bytes
    const ciphertextWords = combinedBytes.words.slice(4);
    const ciphertext = CryptoJS.lib.WordArray.create(
      ciphertextWords,
      combinedBytes.sigBytes - 16
    );

    const decrypted = CryptoJS.AES.decrypt(
      { ciphertext },
      CryptoJS.enc.Utf8.parse(SECRET_KEY_STRING),
      {
        iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
      }
    );
    const result = decrypted.toString(CryptoJS.enc.Utf8);
    return result || '_--_';
  } catch (e) {
    console.log('decryptAES error:', e);
    return '';
  }
};

export const getCurrentAndLastThreeMonthDate = (targetDateString: string) => {
  const targetDate = new Date(targetDateString);

  // Get date 90 days before
  const pastDate = new Date(targetDate);
  pastDate.setDate(targetDate.getDate() - 90);

  const formatDate = (date) => {
    return date.toISOString().split('T')[0];
  };
  const firstDate = formatDate(pastDate);
  const lastDate = formatDate(targetDate);

  return {
    firstDate,
    lastDate,
  };
};

export const getAccountId = () => {
  const ls = new SecureLS({ encodingType: 'aes' });
  const user = ls.get('user');
  const userData = user && JSON.parse(user);
  const accountId = userData?.accountId;
  return accountId || null;
};

export const getCustomerId = () => {
  const ls = new SecureLS({ encodingType: 'aes' });
  const user = ls.get('user');
  const userData = user && JSON.parse(user);
  const customer_id = userData?.customerId;
  return customer_id || null;
};
export const webformatDate = (dateString: string, locale = 'en') => {
  if (!dateString) return '';
  // Use moment to avoid timezone issues
  const momentLocale = locale?.includes('fr') ? 'fr' : 'en';
  return moment(dateString).locale(momentLocale).format('MMM DD, YYYY');
};

export const getFullStatements = (
  accountDetails,
  statements,
  nextEndDate,
  lastLoadedDated
) => {
  const dummyStatementForDate = (cycleDate) => {
    const date = moment(cycleDate, 'YYYY-MM-DD');
    const statementDate = date.clone().format('YYYY-MM-DD');
    return {
      cycleDate: date.format('YYYY-MM-DD'),
      statementDate,
      statementId: null,
      statementType: 'MONTHLY',
    };
  };

  const getMonthYear = (dateStr) => {
    const date = dateStr ? moment.utc(dateStr) : moment().subtract(6, 'months');
    return date.format('YYYY-MM-DD');
  };

  const getDateSixMonthsFromNow = (number) =>
    moment().subtract(number, 'months').startOf('month').format('YYYY-MM-DD');

  // If there are real statements
  if (statements && statements.length > 0) {
    // Group statements by month key YYYY-MM
    const monthToStatements = {};
    statements.forEach((s) => {
      if (!s?.cycleDate) return;
      const monthKey = moment(s.cycleDate, 'YYYY-MM-DD').format('YYYY-MM');
      monthToStatements[monthKey] = monthToStatements[monthKey] || [];
      monthToStatements[monthKey].push(s);
    });

    // Sort each month's statements in descending order by cycleDate (newest first)
    Object.keys(monthToStatements).forEach((k) => {
      monthToStatements[k].sort((a, b) =>
        moment(b.cycleDate, 'YYYY-MM-DD').diff(
          moment(a.cycleDate, 'YYYY-MM-DD')
        )
      );
    });

    // Build uniqueCycleDates array (distinct cycleDates) sorted descending
    const allCycleDates = [
      ...accountDetails.cycleDates,
      ...statements.map((s) => s.cycleDate),
    ];
    const uniqueCycleDates = [...new Set(allCycleDates)].sort((a, b) =>
      moment(b, 'YYYY-MM-DD').diff(moment(a, 'YYYY-MM-DD'))
    );

    // determine fallback target month/year
    const previousSixMonthfromNow = getDateSixMonthsFromNow(6);

    // determine target month-year (end)
    const targetMonthYear = getMonthYear(
      nextEndDate !== ''
        ? nextEndDate
        : uniqueCycleDates.length > 6 ||
            moment(
              uniqueCycleDates[uniqueCycleDates.length - 1],
              'YYYY-MM-DD'
            ).isSameOrBefore(moment(lastLoadedDated, 'YYYY-MM-DD'))
          ? uniqueCycleDates[uniqueCycleDates.length - 1]
          : lastLoadedDated !== ''
            ? lastLoadedDated
            : previousSixMonthfromNow
    );

    // start = newest available cycle date, end = targetMonthYear
    const startMoment = moment(uniqueCycleDates[0], 'YYYY-MM-DD');
    const endMoment = moment(targetMonthYear, 'YYYY-MM-DD');

    // if start is earlier than end, nothing to produce (you can change to swap if desired)
    if (startMoment.isBefore(endMoment, 'day')) {
      return [];
    }

    // iterate month-by-month descending
    const results = [];
    let cursor = startMoment.clone();

    while (cursor.isSameOrAfter(endMoment, 'day')) {
      const monthKey = cursor.format('YYYY-MM');

      if (
        Array.isArray(monthToStatements[monthKey]) &&
        monthToStatements[monthKey].length
      ) {
        // emit all statements for this month (already sorted newest-first)
        monthToStatements[monthKey].forEach((stmt) => results.push(stmt));
      } else {
        // no real statements this month — emit one dummy
        results.push(dummyStatementForDate(cursor.format('YYYY-MM-DD')));
      }
      cursor.subtract(1, 'month');
    }
    return results;
  }

  // If no statements but nextEndDate provided — generate dummy statements from accountDetails.cycleDates
  if (nextEndDate && nextEndDate !== '') {
    const today = moment().startOf('day');
    const end = moment(nextEndDate).endOf('day');

    const start = moment.min(today, end);
    const stop = moment.max(today, end);

    const dummyStatements = (accountDetails?.cycleDates || [])
      .filter((cd) => {
        const m = moment(cd, 'YYYY-MM-DD');
        return m.isSameOrAfter(start) && m.isSameOrBefore(stop);
      })
      .map((cd) => dummyStatementForDate(cd));
    // sort newest first
    return dummyStatements.sort((a, b) =>
      moment(b.cycleDate).diff(moment(a.cycleDate))
    );
  }
  // nothing to return
  return [];
};
export const getTokens = async () => {
  try {
    let tokensString: string | null = '';
    if (isWeb) {
      const ls = new SecureLS({ encodingType: 'aes' });
      tokensString = ls.get('tokens');
    } else {
      tokensString = await AsyncStorage.getItem('tokens');
    }
    const tokens = tokensString ? JSON.parse(tokensString) : null;
    return tokens;
  } catch (error) {
    console.error('Error retrieving tokens:', error);
    return null;
  }
};

export function isRefreshFalse(url) {
  const patterns = [
    /^\/corebank\/v1\/account\/[^/]+\/customer\/[^/]+\/estatement\/[^/]+\/view$/,
    /^\/corebank\/v1\/testing\/[^/]+\/details$/, // example
    /^\/corebank\/v1\/authenticate\/twofactorpasscode\/preferences\/user$/,
  ];
  return patterns.some((regex) => regex.test(url));
}

export function getRewardsHistoryEarnedCapBannerMessage(
  rb_earned_rewards_history,
  rb_common,
  rewardsPercentageDate,
  accountDetails,
  setIsPercentage,
  setCashBackPercent,
  setCashBackInfoTipDetails
) {
  const isExistingCustomer = moment(
    accountDetails?.openedDate,
    'YYYY-MM-DD',
    true
  ).isBefore(moment('2026-08-04', 'YYYY-MM-DD'), 'day');
  console.log('isExistingCustomer', isExistingCustomer);
  const isAnniversaryDateHidden =
    rb_earned_rewards_history?.rewardsHistory
      ?.earnedRewardsMessageAnniversaryDateFF;
  const percentage =
    rewardsPercentageDate?.rciEmployeeDetail?.currentCashBackPercent;
  const rewardsDate =
    rewardsPercentageDate?.rciEmployeeDetail?.currentCashBackPercentDate;
  if (rewardsPercentageDate?.statusCode === 200) {
    setIsPercentage(false);
    const anniversaryDate =
      rewardsPercentageDate?.rciEmployeeDetail?.earnCap?.anniversaryDate;
    const resetOnAnniversaryDate =
      !isAnniversaryDateHidden && anniversaryDate
        ? `${rb_earned_rewards_history?.rewardsHistory?.earnedRewardsMessageAnniversaryDateWithRogers || ''} ${moment(anniversaryDate).format('MM-DD-YYYY')}.`
        : '';
    if (
      percentage &&
      (rb_common?.commonString?.worldElite === accountDetails?.productName ||
        rb_common?.commonString?.rogersMastercard ===
          accountDetails?.productName ||
        rb_common?.commonString?.worldMasterCardProductName ===
          accountDetails?.productName)
    ) {
      if (rewardsPercentageDate?.rciEmployeeDetail?.employeeFlag === 'E') {
        if (
          rewardsDate &&
          rewardsPercentageDate?.rciEmployeeDetail?.linkageStatus === '1'
        ) {
          setCashBackPercent(
            `${rb_earned_rewards_history?.rewardsHistory?.earnedRewardsMessageTitle || ''} ${percentage + '%'} ${rb_earned_rewards_history?.rewardsHistory?.earnedRewardsMessageDateWithRogers || ''} ${moment(rewardsDate).format('MM-DD-YYYY')}.`
          );
        } else {
          setCashBackPercent(
            `${rb_earned_rewards_history?.rewardsHistory?.earnedRewardsMessageTitle || ''} ${percentage + '%'} ${rb_earned_rewards_history?.rewardsHistory?.earnedRewardsMessageWithNoRogers || ''}`
          );
        }
        setCashBackInfoTipDetails(
          rb_earned_rewards_history?.rewardsHistory
            ?.twoPercentCashBackToolTips || ''
        );
      } else {
        if (rewardsPercentageDate?.rciEmployeeDetail?.linkageStatus === '1') {
          if (
            rewardsPercentageDate?.rciEmployeeDetail?.earnCap?.reached === 'Y'
          ) {
            setCashBackPercent(
            `${rb_earned_rewards_history?.rewardsHistory?.earnedRogersRewardsMessageTitle || ''} ${percentage + '%'} ${rb_earned_rewards_history?.rewardsHistory?.earnedRewardsMessageDateWithRogers || ''} ${moment(rewardsPercentageDate?.rciEmployeeDetail?.earnCap?.reachedDate).format('MM-DD-YYYY')}. ${resetOnAnniversaryDate}`
          );
            setCashBackInfoTipDetails(
              rb_earned_rewards_history?.rewardsHistory?.linkedCapReached || ''
            );
          } else {
            setCashBackPercent(
            `${rb_earned_rewards_history?.rewardsHistory?.earnedRogersRewardsMessageTitle || ''} ${percentage + '%'} ${rb_earned_rewards_history?.rewardsHistory?.earnedRewardsMessageDateWithRogers || ''} ${moment(rewardsDate).format('MM-DD-YYYY')}. ${resetOnAnniversaryDate}`
          );
            if (isExistingCustomer) {
              setCashBackInfoTipDetails(
                rb_earned_rewards_history?.rewardsHistory
                  ?.linkedCapNotReachedExisting || ''
              );
            } else {
              setCashBackInfoTipDetails(
                rb_earned_rewards_history?.rewardsHistory
                  ?.linkedCapNotReachedNew || ''
              );
            }
          }
        } else {
          setCashBackPercent(
            `${rb_earned_rewards_history?.rewardsHistory?.earnedRewardsMessageTitle || ''} ${percentage + '%'} ${rb_earned_rewards_history?.rewardsHistory?.earnedRewardsMessageWithNoRogers || ''} ${resetOnAnniversaryDate}`
          );
          if (
            rewardsPercentageDate?.rciEmployeeDetail?.earnCap?.reached === 'Y'
          ) {
            setCashBackInfoTipDetails(
              rb_earned_rewards_history?.rewardsHistory?.notLinkedCapReached ||
                ''
            );
          } else {
            if (isExistingCustomer) {
              setCashBackInfoTipDetails(
                rb_earned_rewards_history?.rewardsHistory
                  ?.notLinkedCapNotReachedExisting || ''
              );
            } else {
              setCashBackInfoTipDetails(
                rb_earned_rewards_history?.rewardsHistory
                  ?.notLinkedCapNotReachedNew || ''
              );
            }
          }
        }
      }
    } else if (
      percentage &&
      rb_common?.commonString?.rogersPlatinum === accountDetails?.productName
    ) {
      setCashBackPercent(
        `${rb_earned_rewards_history?.rewardsHistory?.earnedRewardsMessageTitle || ''} ${percentage + '%'} ${rb_earned_rewards_history?.rewardsHistory?.earnedRewardsMessageWithNoRogers || ''}`
      );
      setCashBackInfoTipDetails(
        rb_earned_rewards_history?.rewardsHistory?.twoPercentCashBackToolTips ||
          ''
      );
    } else if (
      percentage &&
      rb_common?.commonString?.fidoCashback === accountDetails?.productName
    ) {
      setCashBackPercent(
        `${rb_earned_rewards_history?.rewardsHistory?.earnedRewardsMessageTitle || ''} ${percentage + '%'} ${rb_earned_rewards_history?.rewardsHistory?.earnedRewardsMessageWithFidoNoRogers || ''}`
      );
      setCashBackInfoTipDetails(
        rb_earned_rewards_history?.rewardsHistory?.twoPercentCashBackToolTips ||
          ''
      );
    } else if (
      percentage &&
      rb_common?.commonString?.smbProductName === accountDetails?.productName
    ) {
      if (rewardsDate) {
        setCashBackPercent(
          `${rb_earned_rewards_history?.rewardsHistory?.earnedRewardsMessageTitle || ''} ${percentage + '%'} ${rb_earned_rewards_history?.rewardsHistory?.earnedRewardsMessageDateWithRogers || ''} ${moment(rewardsDate).format('MM-DD-YYYY')}.`
        );
      } else {
        setCashBackPercent(
          `${rb_earned_rewards_history?.rewardsHistory?.earnedRewardsMessageTitle || ''} ${percentage + '%'} ${rb_earned_rewards_history?.rewardsHistory?.earnedRewardsMessageWithNoRogers || ''}`
        );
      }
      setCashBackInfoTipDetails(
        rb_earned_rewards_history?.rewardsHistory?.twoPercentCashBackToolTips ||
          ''
      );
    } else if (
      percentage &&
      rb_common?.commonString?.legendProductName === accountDetails?.productName
    ) {
      if (rewardsDate) {
        setCashBackPercent(
          `${rb_earned_rewards_history?.rewardsHistory?.earnedRewardsMessageTitle || ''} ${percentage + '%'} ${rb_earned_rewards_history?.rewardsHistory?.earnedRewardsMessageDateWithRogers || ''} ${moment(rewardsDate).format('MM-DD-YYYY')}.`
        );
      } else {
        setCashBackPercent(
          `${rb_earned_rewards_history?.rewardsHistory?.earnedRewardsMessageTitle || ''} ${percentage + '%'} ${rb_earned_rewards_history?.rewardsHistory?.earnedRewardsMessageWithNoRogers || ''}`
        );
      }
      setCashBackInfoTipDetails(
        rb_earned_rewards_history?.rewardsHistory?.twoPercentCashBackToolTips ||
          ''
      );
    } else {
      setCashBackPercent(
        `${rb_earned_rewards_history?.rewardsHistory?.earnedRewardsMessageTitle || ''} ${rb_earned_rewards_history?.rewardsHistory?.fidoMastercard} ${rb_earned_rewards_history?.rewardsHistory?.earnedRewardsMessageWithFidoNoRogers || ''}`
      );
      setCashBackInfoTipDetails(
        rb_earned_rewards_history?.rewardsHistory?.twoPercentCashBackToolTips ||
          ''
      );
    }
  } else if (
    rewardsPercentageDate?.statusCode === 422 ||
    !percentage ||
    !rewardsDate
  ) {
    const anniversaryDate =
      rewardsPercentageDate?.rciEmployeeDetail?.earnCap?.anniversaryDate;
    const resetOnAnniversaryDate =
      !isAnniversaryDateHidden && anniversaryDate
        ? `${rb_earned_rewards_history?.rewardsHistory?.earnedRewardsMessageAnniversaryDateWithRogers || ''} ${moment(anniversaryDate).format('MM-DD-YYYY')}.`
        : '';
    if (
      rb_common.commonString.worldElite === accountDetails?.productName ||
      rb_common.commonString.rogersMastercard === accountDetails?.productName ||
      rb_common.commonString.worldMasterCardProductName ===
        accountDetails?.productName
    ) {
      setCashBackPercent(
        `${rb_earned_rewards_history?.rewardsHistory?.earnedRewardsMessageTitle || ''} ${rb_common.commonString.worldElite === accountDetails?.productName ? rb_earned_rewards_history?.rewardsHistory?.rogersRedWorldElite : rb_common.commonString.rogersMastercard === accountDetails?.productName ? rb_earned_rewards_history?.rewardsHistory?.rogersRedMastercard : rb_earned_rewards_history?.rewardsHistory?.worldMasterCard} ${rb_earned_rewards_history?.rewardsHistory?.earnedRewardsMessageWithNoRogers || ''} ${resetOnAnniversaryDate}`
      );
      if (rewardsPercentageDate?.rciEmployeeDetail?.earnCap?.reached === 'Y') {
        setCashBackInfoTipDetails(
          rb_earned_rewards_history?.rewardsHistory?.notLinkedCapReached || ''
        );
      } else {
        if (isExistingCustomer) {
          setCashBackInfoTipDetails(
            rb_earned_rewards_history?.rewardsHistory
              ?.notLinkedCapNotReachedExisting || ''
          );
        } else {
          setCashBackInfoTipDetails(
            rb_earned_rewards_history?.rewardsHistory
              ?.notLinkedCapNotReachedNew || ''
          );
        }
      }
    } else if (
      rb_common.commonString.rogersPlatinum === accountDetails?.productName
    ) {
      setCashBackPercent(
        `${rb_earned_rewards_history?.rewardsHistory?.earnedRewardsMessageTitle || ''} ${rb_earned_rewards_history?.rewardsHistory?.platinumMasterCard} ${rb_earned_rewards_history?.rewardsHistory?.earnedRewardsMessageWithNoRogers || ''}`
      );
      setCashBackInfoTipDetails(
        rb_earned_rewards_history?.rewardsHistory?.twoPercentCashBackToolTips ||
          ''
      );
    } else if (
      rb_common.commonString.fidoCashback === accountDetails?.productName
    ) {
      setCashBackPercent(
        `${rb_earned_rewards_history?.rewardsHistory?.earnedRewardsMessageTitle || ''} ${rb_earned_rewards_history?.rewardsHistory?.fidoMastercard} ${rb_earned_rewards_history?.rewardsHistory?.earnedRewardsMessageWithFidoNoRogers || ''}`
      );
      setCashBackInfoTipDetails(
        rb_earned_rewards_history?.rewardsHistory?.twoPercentCashBackToolTips ||
          ''
      );
    } else if (
      rb_common.commonString.smbProductName === accountDetails?.productName
    ) {
      setCashBackPercent(
        `${rb_earned_rewards_history?.rewardsHistory?.earnedRewardsMessageTitle || ''} ${rb_earned_rewards_history?.rewardsHistory?.rogersSmallBusiness} ${rb_earned_rewards_history?.rewardsHistory?.earnedRewardsMessageWithNoRogers || ''}`
      );
      setCashBackInfoTipDetails(
        rb_earned_rewards_history?.rewardsHistory?.twoPercentCashBackToolTips ||
          ''
      );
    } else if (
      rb_common.commonString.legendProductName === accountDetails?.productName
    ) {
      setCashBackPercent(
        `${rb_earned_rewards_history?.rewardsHistory?.earnedRewardsMessageTitle || ''} ${rb_earned_rewards_history?.rewardsHistory?.legendMastercard} ${rb_earned_rewards_history?.rewardsHistory?.earnedRewardsMessageWithNoRogers || ''}`
      );
      setCashBackInfoTipDetails(
        rb_earned_rewards_history?.rewardsHistory?.twoPercentCashBackToolTips ||
          ''
      );
    }
  } else {
    setIsPercentage(true);
    setCashBackPercent('');
    setCashBackInfoTipDetails('');
  }
}
